import { qs } from "../utils/dom.js";

export function renderFAQ() {
  const mount = qs("#faq");
  if (!mount) {
    // console.warn("FAQ element not found");
    return;
  }

  const allFaq = document.querySelectorAll(".faqElement");

  allFaq.forEach((item) => {
    const icon = item.querySelector("img");
    if (icon) {
      icon.src = "./public/svg/faq-arrow-light.svg";
    }

    item.addEventListener("click", () => {
      const faqText = item.nextElementSibling;
      const isOpen = faqText.style.display !== "none";
      faqText.style.display = isOpen ? "none" : "block";
      const faqBlock = item.closest(".faqBlock");
      if (faqBlock) {
        faqBlock.classList.toggle("is-open", !isOpen);
      }
      if (icon) {
        icon.src = isOpen
          ? "./public/svg/faq-arrow-light.svg"
          : "./public/svg/faq-arrow-dark.svg";
      }
    });
  });
}
